export class RouteLineTimetableDescription {
  constructor(
    readonly id: number,
    readonly description: string,
  ) {}

  public static fromBE(plain: RouteLineTimetableDescriptionBE) {
    const { id, description } = plain;
    return new RouteLineTimetableDescription(id, description);
  }
}

export interface RouteLineTimetableDescriptionBE {
  readonly id: number;
  readonly description: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/RouteLineTimetableDescription.ts